import { LoginFormData } from 'mk2/apps/users/components/LoginForm';
import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';
import { AppStateProvidedFromServer } from 'mk2/reducers';
import { UserEntity } from 'mk2/schemas';

///////////////////////////////////////////////////////////////////
// Login form

export const LOGIN_TRIGGER = 'LOGIN_TRIGGER';
export interface LoginTriggerAction {
    readonly type: typeof LOGIN_TRIGGER;
    readonly loginFd: LoginFormData;
}
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export interface LoginRequestAction extends APIRequestAction {
    readonly type: typeof LOGIN_REQUEST;
    readonly loginFd: LoginFormData;
}
export interface LoginNormalizedResponse extends NormalizedResponse {
    readonly result: { user: number; };
}
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export interface LoginSuccessAction extends APISuccessAction<LoginNormalizedResponse> {
    readonly type: typeof LOGIN_SUCCESS;
    readonly loginFd: LoginFormData;
    readonly user: UserEntity;
    readonly initialState: AppStateProvidedFromServer;
}
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export interface LoginFailureAction extends APIFailureAction {
    readonly type: typeof LOGIN_FAILURE;
    readonly loginFd: LoginFormData;
}

export const loginTrigger =  (loginFd: LoginFormData): LoginTriggerAction => ({
    type: LOGIN_TRIGGER, loginFd,
});
export const loginAPI = {
    request: (loginFd: LoginFormData): LoginRequestAction => ({
        type: LOGIN_REQUEST, loginFd,
    }),
    success: (loginFd: LoginFormData, user: UserEntity, initialState: AppStateProvidedFromServer, response: LoginNormalizedResponse): LoginSuccessAction => ({
        type: LOGIN_SUCCESS, loginFd, user, initialState, response,
    }),
    failure: (loginFd: LoginFormData, error: any): LoginFailureAction => ({
        type: LOGIN_FAILURE, loginFd, error,
    }),
};

///////////////////////////////////////////////////////////////////
// Check One-Time Login Link

export const CHECK_ONETIME_LOGIN_LINK_TRIGGER = 'CHECK_ONETIME_LOGIN_LINK_TRIGGER';
export interface CheckOneTimeLoginLinkTriggerAction {
    readonly type: typeof CHECK_ONETIME_LOGIN_LINK_TRIGGER;
    readonly otlHash: string;
}
export const CHECK_ONETIME_LOGIN_LINK_REQUEST = 'CHECK_ONETIME_LOGIN_LINK_REQUEST';
export interface CheckOneTimeLoginLinkRequestAction extends APIRequestAction {
    readonly type: typeof CHECK_ONETIME_LOGIN_LINK_REQUEST;
    readonly otlHash: string;
}
export interface CheckOneTimeLoginLinkNormalizedResponse extends NormalizedResponse {
    readonly result: { user: number; };
}
export const CHECK_ONETIME_LOGIN_LINK_SUCCESS = 'CHECK_ONETIME_LOGIN_LINK_SUCCESS';
export interface CheckOneTimeLoginLinkSuccessAction extends APISuccessAction<CheckOneTimeLoginLinkNormalizedResponse> {
    readonly type: typeof CHECK_ONETIME_LOGIN_LINK_SUCCESS;
    readonly otlHash: string;
    readonly user: UserEntity;
    readonly initialState: AppStateProvidedFromServer;
}
export const CHECK_ONETIME_LOGIN_LINK_FAILURE = 'CHECK_ONETIME_LOGIN_LINK_FAILURE';
export interface CheckOneTimeLoginLinkFailureAction extends APIFailureAction {
    readonly type: typeof CHECK_ONETIME_LOGIN_LINK_FAILURE;
    readonly otlHash: string;
}

export const checkOneTimeLoginLinkTrigger =  (otlHash: string): CheckOneTimeLoginLinkTriggerAction => ({
    type: CHECK_ONETIME_LOGIN_LINK_TRIGGER, otlHash,
});
export const checkOneTimeLoginLinkAPI = {
    request: (otlHash: string): CheckOneTimeLoginLinkRequestAction => ({
        type: CHECK_ONETIME_LOGIN_LINK_REQUEST, otlHash,
    }),
    success: (otlHash: string, user: UserEntity, initialState: AppStateProvidedFromServer, response: CheckOneTimeLoginLinkNormalizedResponse): CheckOneTimeLoginLinkSuccessAction => ({
        type: CHECK_ONETIME_LOGIN_LINK_SUCCESS, otlHash, user, initialState, response,
    }),
    failure: (otlHash: string, error: any): CheckOneTimeLoginLinkFailureAction => ({
        type: CHECK_ONETIME_LOGIN_LINK_FAILURE, otlHash, error,
    }),
};
